import { useTranslation } from "react-i18next";

export const useI18tools = () => {
  const { t } = useTranslation();

  const tools = [
    {
      id: "1",
      title: t("header.tools.title.1"),
      description: t("header.tools.description.1"),
      link: "/tools/my-anonymity/",
    },
    {
      id: "2",
      title: t("header.tools.title.2"),
      description: t("header.tools.description.2"),
      link: "/tools/check-dns/",
    },
    {
      id: "3",
      title: t("header.tools.title.3"),
      description: t("header.tools.description.3"),
      link: "/tools/port-scanner/",
    },
    {
      id: "4",
      title: t("header.tools.title.4"),
      description: t("header.tools.description.4"),
      link: "/tools/check-spam-database/",
    },
    {
      id: "5",
      title: t("header.tools.title.5"),
      description: t("header.tools.description.5"),
      link: "/tools/ip-tracing/",
    },
    {
      id: "6",
      title: t("header.tools.title.6"),
      description: t("header.tools.description.6"),
      link: "/tools/check-evercookie/",
    },
    {
      id: "7",
      title: t("header.tools.title.7"),
      description: t("header.tools.description.7"),
      link: "/tools/header-viewer/",
    },
    {
      id: "8",
      title: t("header.tools.title.8"),
      description: t("header.tools.description.8"),
      link: "/tools/browser-info/",
    },
    {
      id: "9",
      title: t("header.tools.title.9"),
      description: t("header.tools.description.9"),
      link: "/tools/fingerprint-scanner/",
    },
    {
      id: "10",
      title: t("header.tools.title.10"),
      description: t("header.tools.description.10"),
      link: "/tools/check-webrtc/",
    },
  ];

  return { tools };
};
